/*
 * @FilePath: \kitchen-online-web\src\redux\reducers\storage.js
 * @Author: Yu Wang
 * @Date: 2021-08-02 13:23:14
 * @LastEditors: Yu Wang
 * @LastEditTime: 2022-04-19 14:10:00
 */
const storageAction = {
  'drawer-detail': (state, payload) => ({
    // 抽屉信息
    ...state,
    storage: {
      ...state.storage,
      drawer: {
        ...payload,
      },
    },
  }),
  'bask-top-detail': (state, payload) => ({
    // 顶柜转篮
    ...state,
    storage: {
      ...state.storage,
      basketTop: {
        ...payload,
      },
    },
  }),
  'sink-detail': (state, payload) => ({
    // 水槽信息
    ...state,
    storage: {
      ...state.storage,
      sink: {
        ...payload,
      },
    },
  }),
  'tallark-detail': (state, payload) => ({
    // 高柜信息
    ...state,
    storage: {
      ...state.storage,
      tallArk: [...payload],
    },
  }),
  'hand-detail': (state, payload) => ({
    // 把手信息
    ...state,
    storage: {
      ...state.storage,
      hand: {
        ...payload,
      },
    },
  }),
  'checked-tablist': (state, payload) => ({
    // tab是否可以点击,暂无用
    ...state,
    checkedTabList: payload,
  }),
  'drawer-num': (state, payload) => ({
    // 抽屉数量
    ...state,
    drawerNum: Object.assign([], { ...state.drawerNum, ...payload }),
  }),
  'basket-top-num': (state, payload) => ({
    // 顶柜内配数量
    ...state,
    topBaskNum: Object.assign([], { ...state.topBaskNum, ...payload }),
  }),
  'basket-under-num': (state, payload) => ({
    // 底柜内配数量
    ...state,
    underBaskNum: Object.assign([], { ...state.underBaskNum, ...payload }),
  }),
  faucetComponentId: (state, payload) => ({
    // 水龙头id
    ...state,
    faucetComponentId: payload,
  }),
  setOldTemplate: (state, payload) => ({
    ...state,
    oldTemplate: payload,
  }),
  // 3105AB测试
  comboChange: (state, payload) => ({
    ...state,
    selectCombo: payload,
  }),
};

export default storageAction;
